'use client';

import { Column } from '@viewup/ui';
import { SubHeaderLayout } from 'app/_components';
import { HideBottomBarHoc } from 'app/_hook';
import { useSearchParams } from 'next/navigation';
import { PrivacyService } from '../PrivacyService/PrivacyService';
import { TermsService } from '../TermsService';

export const PrivacyClientPage = HideBottomBarHoc(() => {
  const params = useSearchParams();

  return (
    <SubHeaderLayout title={params.get('type') === 'service' ? '이용약관' : '개인정보취급방침'}>
      <Column css={{ whiteSpace: 'pre-wrap' }} p={24}>
        {params.get('type') === 'service' ? <TermsService /> : <PrivacyService />}
      </Column>
    </SubHeaderLayout>
  );
});
